module.exports = __webpack_public_path__ + "static/media/Puzzle_Safe.afe02f11.png";